<form [formGroup]="bulkForm" class="container">
    <mat-card>
        <!-- <mat-card-title>Bulk CSV Upload</mat-card-title> -->
        <mat-card-content>

            <div class="row" class="mr-10">
                <p class="para">
                    {{'InstructionsBulkUpload'|translate}}
                </p>
            </div>

            <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Mfg. Date*</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Batch number</mat-label>
                    <input matInput formControlName="batchNumber">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Lot number</mat-label>
                    <input matInput formControlName="lotNumber">
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Sensor IDs (Format: WUYYWWXXXXXX, CSV)</mat-label>
                <textarea matInput rows="6" formControlName="csvData"
                    placeholder="Enter or paste sensor IDs in WUYYWWXXXXXX format, comma-separated"
                    (input)="onCsvInputChange($event.target.value)"></textarea>
            </mat-form-field>

            <div class="actions">
                <button mat-raised-button color="accent" (click)="validateCsv()">{{'Validate'|translate}}</button>
                <button mat-raised-button color="primary" [disabled]="isGenerateDisabled()"
                    (click)="generate()">{{'Proceed'|translate}}</button>
            </div>

            <!-- Preview table -->

            <table mat-table [dataSource]="parsedRows" *ngIf="parsedRows.length" class="full-width">
                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef>Sensor ID</th>
                    <td mat-cell *matCellDef="let row">{{row.value}}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-icon color="primary" *ngIf="row.isValid">check_circle</mat-icon>
                        <mat-icon color="warn" *ngIf="!row.isValid">error</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="error">
                    <th mat-header-cell *matHeaderCellDef>Error</th>
                    <td mat-cell *matCellDef="let row">{{row.error||'-'}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</form>